import React, { Component} from 'react';
import { Modal, Button,Table, Tooltip, Icon } from 'antd';
import TableC from '../../basicElement/TableC';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import Helmet from 'react-helmet';

class PersonalView extends Component {
    state = {
        visible: false,
        loading:false,
        data: [],
        record: {},
        sortParams: {},
        searchParams: {},
    }

    loadData = () => {
        const { searchParams } = this.state;
        const { time } = searchParams;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryUserEfficiencyInfoByUserId,
            data: {
                offset: 1,
                ...searchParams,
                begin: time,
                end: time,
            },
            dataType: 'json',
            doneResult: res => {
                const { efficiencyBeanList } = res;
                this.setState({
                    loading: false,
                    data: efficiencyBeanList || [],
                });
            }
        };
        $.sendRequest(options);
    }

    show = (record = {}) => {
        const { userId,time } = record;
        this.setState({
            record,
            visible: true,
            searchParams: {
                userId,
                userInTeam: 'false',
                time,
            }
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    getRender = text => text || '-'

    getColumns = () => [{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        fixed: 'left',
        width: 60
    }, {
        title: '项目编号',
        dataIndex: 'investigationCode',
        key: 'investigationCode',
        fixed: 'left',
        width: 100,
        render: this.getRender,
    }, {
        title: 'JDE主项目号',
        dataIndex: 'mainCode',
        key: 'mainCode',
        fixed: 'left',
        width: 120
    },  {
        title: '项目简称',
        dataIndex: 'investigationName',
        key: 'investigationName',
        fixed: 'left',
        width: 120
    }, {
        title: '业务线',
        dataIndex: 'lineOfBusinessString',
        key: 'lineOfBusinessString',
        width: 80,
    }, {
        title: '执行业务线二级分类',
        dataIndex: 'secondLineNames',
        key: 'secondLineNames',
        width: 80,
    }, {
        title: '项目领域',
        dataIndex: 'investigationAreaName',
        key: 'investigationAreaName',
        width: 100
    }, {
        title: '疾病',
        dataIndex: 'diseaseName',
        key: 'diseaseName',
        width: 100
    }, {
        title: '领域leader',
        dataIndex: 'leaderNameCode',
        key: 'leaderNameCode',
        width: 100,
    }, {
        title: '项目阶段',
        dataIndex: 'stageName',
        key: 'stageName',
        width: 100
    }, {
        title: 'PM工号',
        dataIndex: 'pmCode',
        key: 'pmCode',
        width: 90
    }, {
        title: 'PM姓名',
        dataIndex: 'pmName',
        key: 'pmName',
        width: 90
    }, {
        title: '中心名称',
        dataIndex: 'investigationSiteName',
        key: 'investigationSiteName',
        width: 100
    }, {
        title: '院区',
        dataIndex: 'courtyardArea',
        key: 'courtyardArea',
        width: 100
    }, {
        title: '科室',
        dataIndex: 'departmentName',
        key: 'departmentName',
        width: 100
    }, {
        title: '中心区域',
        dataIndex: 'hospitalAreaName',
        key: 'hospitalAreaName',
        width: 100
    }, {
        title: '中心城市',
        dataIndex: 'hospitalCity',
        key: 'hospitalCity',
        width: 100
    }, {
        title: 'PI',
        dataIndex: 'piName',
        key: 'piName',
        width: 100,
        render: this.getRender,
    }, {
        title: '递交立项资料时间',
        dataIndex: 'submitTimeStr',
        key: 'submitTimeStr',
        width: 150,
        render: this.getRender,
    }, {
        title: '启动时间',
        dataIndex: 'siteStartTimeStr',
        key: 'siteStartTimeStr',
        width: 100,
        render: this.getRender,
    }, {
        title: '启动时长(天)',
        dataIndex: 'siteStartDays',
        key: 'siteStartDays',
        width: 120,
        render: this.getRender,
    }, {
        title: '月入组速率',
        dataIndex: 'randomRate',
        key: 'randomRate',
        width: 120,
        render: this.getRender,
    }, {
        title: '角色',
        dataIndex: 'roleCode',
        key: 'roleCode',
        width: 90
    }, {
        title: '需求类型',
        dataIndex: 'requirementInfoTypeShow',
        key: 'requirementInfoTypeShow',
        width: 90,
        render: this.getRender,
    }, {
        title: '当月项目计划FTE',
        dataIndex: 'planFte',
        key: 'planFte',
        width: 110
    }, {
        title: '当月项目消耗FTE',
        dataIndex: 'consumeFte',
        key: 'consumeFte',
        width: 150
    }, {
        title: '当月筛选数',
        dataIndex: 'filterCount',
        key: 'filterCount',
        width: 130,
    }, {
        title: '累计筛选数',
        dataIndex: 'totalFilterCount',
        key: 'totalFilterCount',
        width: 130,
    }, {
        title: '当月随机数',
        dataIndex: 'randomCount',
        key: 'randomCount',
        width: 130,
    }, {
        title: '累计随机数',
        dataIndex: 'totalRandomCount',
        key: 'totalRandomCount',
        width: 130,
    }, {
        title: '当月在组数',
        dataIndex: 'patientsInProgressNum',
        key: 'patientsInProgressNum',
        width: 130,
        render: this.getRender,
    }, {
        title: '当月完成访视数',
        dataIndex: 'visitCount',
        key: 'visitCount',
        width: 130
    }, {
        title: '累计完成访视数',
        dataIndex: 'totalVisitCount',
        key: 'totalVisitCount',
        width: 130,
    }, {
        title: '当月CRC项目确认FTE',
        dataIndex: 'monthCrcFte',
        key: 'monthCrcFte',
        width: 90,
    }, {
        title: '当月确认标准访视数',
        dataIndex: 'monthStandardVisitCount',
        key: 'monthStandardVisitCount',
        width: 90,
    }, {
        title: '累计确认标准访视数',
        dataIndex: 'standardVisitCount',
        key: 'standardVisitCount',
        width: 90,
    }, {
        title: (
            <span>
                当月CRC访视效率比
                <Tooltip overlayStyle={{ width: 200 }} placement="top" title={'当月CRC访视效率比=当月确认标准访视数/当月CRC项目确认FTE'}>
                    <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                </Tooltip>
            </span>
        ),
        dataIndex: 'visitRate',
        key: 'visitRate',
        width: 150,
    }, {
        title: '中心CRC项目确认FTE',
        dataIndex: 'siteMonthCrcFte',
        key: 'siteMonthCrcFte',
        width: 110,
    }, {
        title: '中心当月确认标准访视数',
        dataIndex: 'siteMonthStandardVisitCount',
        key: 'siteMonthStandardVisitCount',
        width: 110,
    }, {
        title: (
            <span>
                中心访视效率比
                <Tooltip overlayStyle={{ width: 200 }} placement="top" title={'中心当月访视效率比=中心当月确认标准访视数/中心当月CRC项目确认FTE'}>
                    <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                </Tooltip>
            </span>
        ),
        dataIndex: 'siteVisitRate',
        key: 'siteVisitRate',
        width: 110,
    }, {
        title: '当月重大事件数',
        dataIndex: 'majorEventNum',
        key: 'majorEventNum',
        width: 110,
    }, {
        title: '累计重大事件数',
        dataIndex: 'majorEventNumTotal',
        key: 'majorEventNumTotal',
        width: 110,
    }]

    getDataSource = () => {
        const dataSource = [];
        const { data } = this.state;
        if(data && data.length > 0){
            let index = 1;
            data.map((item, i) => {
                if (item.investigationCode != '总计' && item.investigationCode != '汇总') {
                    dataSource.push({
                        id: i,
                        index: index,
                        ...item,
                    });
                    index += 1;
                } else if (item.investigationCode == '总计') {
                    dataSource.push({
                        id: i,
                        index: '总计',
                        ...item,
                        investigationCode: '',
                    });
                } else if (item.investigationCode == '汇总') {
                    dataSource.push({
                        id: i,
                        index: '汇总',
                        ...item,
                        investigationCode: '',
                    });
                }
            });
        }
        return dataSource;
    }

    handleDateChange = (date, dateString, key) => {
        const { searchParams } = this.state;
        searchParams[key] = dateString;
        this.setState({
            searchParams,
        }, () => {
            this.loadData();
        })
    }

    render() {
        const { record, visible, loading, searchParams } = this.state;
        const { time } = searchParams;
        const { employeeCode, userCompellation } = record;
        return (
            <div >
                <Helmet>
                <meta name="description" />
                    <style type="text/css">{`
                            .ant-modal-body{
                                max-height: ${document.documentElement.clientHeight - 200}px;
                            }
                        `}
                </style>
            </Helmet>
                <Modal
                    title="明细记录"
                    visible={visible}
                    onCancel={this.hide}
                    className="preview-modal"
                    width={1200}
                    maskClosable={false}
                    bodyStyle={{ maxHeight: 600 }}
                    footer={<Button key="back" type="ghost" onClick={this.hide}>关闭</Button>}
                >
                    <div className="cont" style={{padding: '20px 20px 10px'}}>
                        <div>
                            工号：{employeeCode}  
                            <span className="ant-divider" />
                            姓名：{userCompellation}
                            <span className="ant-divider" />
                            时间：{time}
                        </div>
                        <div style={{margin:'20px 0'}} >
                            <TableC
                                columns={this.getColumns()}
                                data={this.getDataSource()}
                                rowKey="id"
                                loading={loading}
                                scrollY={440}
                            />
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

class TeamView extends Component {
    state = {
        visible: false,
        loading:false,
        data: [],
        record: {},
        searchParams: {},
    }

    loadData = () => {
        const { pagination, searchParams  } = this.state;
        const { current, pageSize } = pagination;
        const { time } = searchParams;

        const params = {};
        const array = time.split('.');
        array[1] =  array[1] < 10 ? '0' + array[1] : array[1];
        params.begin = params.end = array.join('-');

        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryPortalUserEfficiency,
            data: {
                offset: current,
                limit: pageSize,
                ...params,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            }
        }
        $.sendRequest(options);
    }

    show = (record = {}) => {
        const { time, leaderId } = record;
        this.setState({
            record,
            visible: true,
            pagination: {
                current: 1,
                pageSize: 5,
            },
            searchParams: {
                time,
                userId: leaderId,
                userInTeam: 'TRUE',
            }
        }, () => {
            this.loadData();
        });
    };

    hide = () => {
        this.setState({ visible: false });
    }

    export = () => {
        const { record, searchParams } = this.state;
        const { year, month } = record;
        const begin = `${year}-${month}`;
        const end = begin;
        ExportUtil.export({...searchParams, begin, end}, null, API_URL.user.exportPortalTeamEfficiencyDetail);
    }

    getColumns = () => [{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        fixed: 'left',
        width: 60,
    }, {
        title: '工号',
        dataIndex: 'employeeCode',
        key: 'employeeCode',
        fixed: 'left',
        width: 80,
    }, {
        title: '姓名',
        dataIndex: 'userCompellation',
        key: 'userCompellation',
        fixed: 'left',
        width: 80,
    }, {
        title: '主管领导',
        dataIndex: 'leaderName',
        key: 'leaderName',
        width: 80,
    }, {
        title: '工作状态',
        dataIndex: 'workStatus',
        key: 'workStatus',
        width: 80,
    },  {
        title: '工作城市',
        dataIndex: 'workCity',
        key: 'workCity',
        width: 80,
    }, {
        title: '项目计划FTE',
        dataIndex: 'planFteString',
        key: 'planFteString',
        width: 105,
    }, {
        title: '项目消耗FTE',
        dataIndex: 'consumeFte',
        key: 'consumeFte',
        width: 105,
    }, {
        title: '完成访视数',
        dataIndex: 'visitCount',
        key: 'visitCount',
        width: 95,
    }, {
        title: 'CRC项目确认FTE',
        dataIndex: 'monthCrcFte',
        key: 'monthCrcFte',
        width: 110,
    }, {
        title: '确认标准访视数',
        dataIndex: 'monthStandardVisitCount',
        key: 'monthStandardVisitCount',
        width: 110,
    }, {
        title: '访视效率比',
        dataIndex: 'visitRate',
        key: 'visitRate',
        width: 95,
    }, {
        title: '方案违背数',
        dataIndex: 'violationCount',
        key: 'violationCount',
        width: 95,
    }, {
        title: (
            <span>
                月空余率
                <Tooltip overlayStyle={{ width: 200 }} placement="top" title={'某月个人空余率 = 1 - 该月个人项目消耗FTE  (若值小于0，取0)'}>
                    <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                </Tooltip>
            </span>
        ),
        dataIndex: 'spareRate',
        key: 'spareRate',
        width: 95,
    }]

    getDataSource = () => {
        const { data, pagination = {} } = this.state;
        const { current, pageSize } = pagination;
        const dataSource = (data || []).map((item, index) => {
            return {
                id: index,
                index: (current - 1 || 0) * pageSize + index + 1,
                ...item,
            };
        });
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        this.setState({
            pagination,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { visible, loading, record, pagination } = this.state;
        const { time, leaderName } = record;
        return (
            <div>
                <Modal
                    title="明细记录"
                    visible={visible}
                    onCancel={this.hide}
                    className="preview-modal"
                    width="900"
                    maskClosable={false}
                    footer={<Button key="back" type="ghost" onClick={this.hide}>关闭</Button>}
                >
                    <div className="cont" style={{padding:'20px 20px 10px'}}>
                        <div>
                            时间：{time}
                            <span className="ant-divider" />
                            团队领导：{leaderName}
                            <Button type="primary" style={{marginLeft: 20}} onClick={this.export}>导出</Button>
                        </div>
                        <div style={{margin:'20px 0'}}>
                            <Table  
                                columns={this.getColumns()}
                                dataSource={this.getDataSource()}
                                rowKey={record => record.id}
                                loading={loading}
                                scroll={{ x: 1270 }}
                                onChange={this.handleTableChange}
                                pagination={pagination}
                            />
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

export { PersonalView, TeamView };


// WEBPACK FOOTER //
// ./src/components/user/userEfficiency/EfficiencyView.js